import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { getPaginatedNodes } from "@/utils/getPaginatedNodes"

const graphQLFragments = {
    product: graphql(`
        fragment getProductTagCodes_Product on Product {
            __typename
            tags(first: 10) {
                edges {
                    node {
                        code
                    }
                }
            }
        }
    `),
}

export function getProductTagCodes(fragment: FragmentOf<typeof graphQLFragments.product>) {
    const product = readFragment(graphQLFragments.product, fragment)

    return getPaginatedNodes(product.tags).map((tag) => tag.code)
}

getProductTagCodes.fragments = graphQLFragments
